export var PATTERN_CIRCLE = 'CIRCLE';
export var PATTERN_PLUS = 'PLUS';
export var PATTERN_SQUARE = 'SQUARE';
export var PATTERN_TYPES = [PATTERN_CIRCLE, PATTERN_PLUS, PATTERN_SQUARE];